import type { BookEventPayload } from './bookEvent.types';

export const CLASSES_VIEW = {
  DAY: 'day',
  LIST: 'list',
  WEEK: 'week',
} as const;

type ShareUrlArgs = {
  absUrl: string;
  branchId: string;
  event: BookEventPayload;
  classesView?: string;
  innerWidth: number;
  startOfDayUnix: (timestamp: number) => number;
  views: typeof CLASSES_VIEW;
};

function classSharePath(args: ShareUrlArgs): string {
  const classesView = !args.classesView || args.innerWidth <= 768
    ? args.views.DAY
    : args.classesView;
  const paths: Record<string, string> = {
    [args.views.DAY]: '/classes-day-view/:classId/book',
    [args.views.LIST]: '/classes-list-view/:classId/book',
    [args.views.WEEK]: '/classes-week-view/:classId/book',
  };
  let path = (paths[classesView] || '').replace(':classId', args.event._id || '');
  if (args.event.time_start) {
    path += `?book_from=${args.startOfDayUnix(args.event.time_start)}`;
  }
  return path;
}

function courseSharePath(event: BookEventPayload): string {
  if (!event.scheduleToBook) {
    return '';
  }
  return '/courses/:courseId/schedule/:scheduleId/book'
    .replace(':courseId', event._id || '')
    .replace(':scheduleId', event.scheduleToBook.id || '');
}

function timeslotSharePath(event: BookEventPayload): string {
  const modelPaths: Record<string, string> = {
    users: '/trainers/:resourceId/timeslots/:timeslotId/book',
    facilities: '/facilities/:resourceId/timeslots/:timeslotId/book',
  };
  return (modelPaths[event.timeslotToBook?.model || ''] || '')
    .replace(':resourceId', event._id || '')
    .replace(':timeslotId', event.timeslotToBook?._id || '');
}

function eventSharePath(args: ShareUrlArgs): string {
  const pathBuilders: Record<string, () => string> = {
    class: () => classSharePath(args),
    course: () => courseSharePath(args.event),
    timeslot: () => timeslotSharePath(args.event),
  };
  return pathBuilders[args.event.type || '']?.() || '';
}

export function buildShareUrl(args: ShareUrlArgs): string {
  const branchUrl = `${args.absUrl.split('#')[0]}#/branch/${args.branchId}`;
  return branchUrl + eventSharePath(args);
}
